export const statuses = {
  static: 'STATIC',
  edit: 'EDIT'
}

export const questionType = {
  text: "text_field",
  checkbox: "yes_no",
  radio: "radio_buttons",
}